<template>
  <tender-form-label :key="index" :label="options.Name" :prop="options.Key" :rules="rules" class="form-input-editor">
    <bear-editor
      v-model="form[options.Key]"
      :value="form[options.Key]"
      :attrs="attrs"
      @input="inputChangeHandle"
      :disabled="options.Disabled"></bear-editor>
  </tender-form-label>
</template>
<script>
import BearEditor from "~@/tinymce-editor/src";
import { mixForFormItem } from "../../../js/mixins";
import utils from "../../../js/utils";
export default {
  name: "FormInputEditor",
  mixins: [mixForFormItem],
  components: { BearEditor },
  created() {
    this.setDefaultValue();
  },
  methods: {
    setDefaultValue() {
      let { form = {}, options = {} } = this;
      utils
        .readyToSetFormItemDefault(form, options)
        .then(() => {
          this.setFormItemValue(options.Value || "");
        })
        .catch(() => null);
    },
    inputChangeHandle() {
      this.doValidate();
    },
  },
};
</script>
<style lang="scss">
.form-input-editor {
  .el-form-item__error {
    float: right;
    position: relative;
    margin: -43px 5px 0 0;
    background: #efdede;
    padding: 3px 10px;
  }
}
</style>